import React from 'react';
import { CtaButton } from './CtaButton';
import { localCurrencyNote } from '../data/content';
export function FinalCta() {
  return <>
      <section aria-labelledby="final-cta-heading" className="relative overflow-hidden bg-navy-900" data-id="element-112" data-mp="vh0q0fhsdpqd">
        <div className="grain absolute inset-0" aria-hidden="true" data-id="element-113" data-mp="19ga7dihqapvx" />
        <div className="relative mx-auto max-w-3xl px-4 py-14 text-center sm:px-5 lg:py-28" data-id="element-114" data-mp="15caqgysjdp21">
          <h2 id="final-cta-heading" className="font-display text-2xl font-extrabold leading-[1.08] tracking-[-0.03em] text-white sm:text-[2.6rem]" data-id="element-115" data-mp="1jc3egmcohr6b">
            Stop the preparation burnout.
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-mist sm:mt-6 sm:text-lg" data-id="element-116" data-mp="1t510v3ksk0a7">
            You are a musician, not a secretary. Get the system that respects your time and your
            talent.
          </p>
          <div className="mt-8 sm:mt-10" data-id="element-117" data-mp="1x4ta7ii0eagm">
            <CtaButton label="Yes, I want it now" size="lg" data-id="element-118" data-mp="1x64gpq2u9wbf" />
          </div>
          <p className="mt-3 text-[13px] text-mist" data-id="element-119" data-mp="n6nul8d98n1j">{localCurrencyNote}</p>
        </div>
      </section>

      <footer className="border-t border-navy-700 bg-navy" data-id="element-120" data-mp="s5qnjufyn2t5">
        <div className="mx-auto flex max-w-page flex-col items-center gap-2 px-5 py-8 sm:flex-row sm:justify-between" data-id="element-121" data-mp="x3s9qo8oni8u">
          <p className="font-display text-xs font-bold uppercase tracking-[0.2em] text-steel" data-id="element-122" data-mp="123emkwklmwh4">
            © The Blues Teacher’s Arsenal™ 2026 — All rights reserved.
          </p>
          <p className="text-xs text-steel" data-id="element-123" data-mp="1b3a0h95jh5ku">7-day money-back guarantee · Secure payment</p>
        </div>
      </footer>
    </>;
}